/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_SeatsInputs */



/**
* | output |
* | --- |
* | "Seats" |
*
* @param {Subscription_SeatsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subscription_seats = /** @type {((inputs?: Subscription_SeatsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_SeatsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Places")
	if (locale === "de") return /** @type {LocalizedString} */ ("Plätze")
	if (locale === "it") return /** @type {LocalizedString} */ ("Postazioni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Места")
	if (locale === "es") return /** @type {LocalizedString} */ ("Puestos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("席位")
	if (locale === "ja") return /** @type {LocalizedString} */ ("席数")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सीटें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Lugares")
	return /** @type {LocalizedString} */ ("Seats")
});